import React from "react";
import "./Terms.css";

const TermsOfUse = () => {
  return (
    <div className="terms-container">
      <h1>Условия использования</h1>
      <p>
        Добро пожаловать на Favorite Crypto Exchange. Используя наш сервис, вы
        соглашаетесь соблюдать настоящие Условия использования. Если вы не
        согласны с ними, пожалуйста, прекратите использование платформы.
      </p>
      
      <h2>Права и обязанности пользователей</h2>
      <p>
        Пользователи обязаны предоставлять достоверную информацию, соблюдать
        правила сервиса и не использовать платформу для незаконных целей.
      </p>
      
      <h2>Ответственность</h2>
      <p>
        Администрация не несет ответственности за возможные убытки, понесенные
        пользователями в результате использования платформы.
      </p>
      
      <h2>Конфиденциальность</h2>
      <p>
        Мы уважаем вашу конфиденциальность и обрабатываем персональные данные в
        соответствии с нашей Политикой конфиденциальности.
      </p>
      
      <h2>Изменения в условиях</h2>
      <p>
        Мы оставляем за собой право вносить изменения в Условия использования в
        любое время. Обновленные версии будут опубликованы на сайте.
      </p>
    </div>
  );
};

export default TermsOfUse;